//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import storage from "local-storage-fallback";
import countryBlocker from "~/middleware/country";
import countries from "~/content/data/countries.json";

export default {
    data() {
        return {
            active: "United States",
            countries,
            phone: "",
            company: "",
            timeZone: "",
            ip: "",
            location: {
                ip: "",
                country_code: "",
                country_name: "",
                time_zone: "",
                timestamp: "",
                zip: "",
            },
            countryListOpen: false,
            countryList: [
                {
                    name: "Australia",
                    code: "AU",
                    dial: "61",
                },
                {
                    name: "Canada",
                    code: "CA",
                    dial: "1",
                },
                {
                    name: "Hongkong",
                    code: "HK",
                    dial: "852",
                },
                {
                    name: "New Zealand",
                    code: "NZ",
                    dial: "64",
                },
                {
                    name: "Philippines",
                    code: "PH",
                    dial: "63",
                },
                {
                    name: "Singapore",
                    code: "SG",
                    dial: "65",
                },
                {
                    name: "United Kingdom",
                    code: "GB",
                    dial: "44",
                },
                {
                    name: "United States",
                    code: "US",
                    dial: "1",
                },
            ],
        };
    },
    computed: {
        subject() {
            return "[" + this.activeCountry.code + "] White Label Reseller Request - " + this.company;
        },
        mobile() {
            return "+" + this.activeCountry.dial + this.phone;
        },
        countryListReverse() {
            return [...this.countryList].reverse();
        },
        activeCountry() {
            const self = this;
            return (
                this.countryList.filter((c) => c.name === self.active)[0] || {
                    name: "United States",
                    code: "US",
                    dial: "1",
                }
            );
        },
        url() {
            return this.site + this.$nuxt.$route.path;
        },
        site() {
            return process.env.SITE_PATH || "https://burstsms.com";
        },
    },
    methods: {
        removeNAN() {
            this.phone = this.phone.replace(/[^.\d]/g, "");
        },
        isNumber(event) {
            if (isNaN(Number(event.key))) {
                return event.preventDefault();
            }
        },
        changeCountry(country) {
            if (this.countryListOpen) {
                if (this.active !== country) {
                    this.active = country;
                }
            }
            this.toggleCountryList();
        },
        toggleCountryList() {
            this.countryListOpen = !this.countryListOpen;
        },
    },
    async created() {
        if ((process.browser || process.client) && process.env && !!process.env.MAINTENANCE) {
            window.location.assign("https://contact.burstsms.com/upgrade?url=" + window.location.href);
        }
        if (process.browser || process.client) {
            await countryBlocker(this.$nuxt.context);
        }
    },
};
